let context= 3; //1 测试环境 2 本地环境 3 线上环境
let server ={};
switch (context) {
    case 3:
        server = {
            requestPath: 'https://xl.honggv.cn:19012/xl-server',
            visualIntercom:'https://xl.honggv.cn:19012/alarm-server',
            uploadPath:'https://xl.oss.honggv.cn:19118',
            IM:'wss://xl.honggv.cn:19210/ws',
            groupMemberId: '',
        }
        break
    default:
        break
}

export default server
